import React from 'react';
import MainLayout from '../Layout/main';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../Components/header-interna';

const Home: React.FC = () => {
    const breadcrumb = [{
        name: 'Página não encontrada',
        slug: '/#',
    }];

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Página não encontrada | Uniexpo</title>
                </Helmet>
            </HelmetProvider>

            <MainLayout>
                <Header title="Página não encontrada" breadcrumb={breadcrumb} />

                <span className="block min-h-[calc(100dvh-845px)]"></span>
            </ MainLayout>
        </>
    );
};

export default Home;
